import { boxPropExclusions } from '../../Box/props.js';
import { createStyledOptions } from './styledConfig.js';

var boxStyledOptions = createStyledOptions(boxPropExclusions);

export { boxStyledOptions };
